module.exports = __webpack_public_path__ + "media/country_flags/gb-nir-fea4038a.png";